module.exports = __webpack_public_path__ + "static/media/health5.94922c41.svg";